import React from 'react';
import { Button } from 'seagull';
import { useGlobalContext, useIoContext, useStoreActions } from "../../../../contexts";
import AddChargeModal from "../../../AddChargeModal/AddChargeModal";
import AddCreditModal from "../../../AddCreditModal/AddCreditModal";
import styles from "./BillingControl.module.scss";
import { timeModel } from "../../../../models";
import { Intent } from "../../../../infra/access-control";
import { startOfDay } from 'date-fns';
export default function BillingControlFooter(props) {
  const {
    agreement,
    totalCredits,
    invoiceDateInfo,
    onRefresh
  } = props;
  const {
    logBI
  } = useStoreActions();
  const {
    getNow
  } = useIoContext();
  const globalContext = useGlobalContext();

  const onAddCredit = () => {
    logBI(18000);
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(AddCreditModal, {
          relationship: agreement,
          nextBillingDate: timeModel.toDatestampObject((invoiceDateInfo === null || invoiceDateInfo === void 0 ? void 0 : invoiceDateInfo.selectedDate) || startOfDay(getNow())),
          dismissModal: dismissModal,
          onRefresh: onRefresh
        });
      }
    });
  };

  const onAddCharge = () => {
    logBI(10566);
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(AddChargeModal, {
          context: {
            relationship: agreement,
            invoiceDateInfo,
            totalCredits
          },
          dismissModal: dismissModal,
          onRefresh: onRefresh
        });
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.footerBtn,
    skin: "primaryOutline",
    onClick: onAddCharge,
    "data-testid": "add-charge-button",
    intent: Intent.AddCharge
  }, "Add Charge"), /*#__PURE__*/React.createElement(Button, {
    className: styles.footerBtn,
    skin: "primaryOutline",
    onClick: onAddCredit,
    "data-testid": "add-credit-button",
    intent: Intent.AddCredit
  }, "Add Credit"));
}